import styled from '@emotion/styled';
import { tokens, Text, BasePopoverContainer } from '@hotjar/hotsauce';

const S = {
  StyledBasedPopoverContainer: styled(BasePopoverContainer)`
    .tippy-content {
      padding: 0;
    }
  `,
  Container: styled.div`
    display: flex;
    flex-direction: column;
    width: 340px;
  `,
  Body: styled.div`
    display: flex;
    flex-direction: column;
  `,
  Header: styled(Text)`
    margin: ${tokens.spacer.x2} 0;
    padding: 0 ${tokens.spacer.x2};
  `,
  Copy: styled(Text)`
    padding: 0 ${tokens.spacer.x2};
    margin-bottom: ${tokens.spacer.x2};
  `,
  Caption: styled(Text)`
    margin-bottom: 0;
    padding-right: ${tokens.spacer.x1};
  `,
  Footer: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: ${tokens.color.bg_info};
    padding: ${tokens.spacer.x2} ${tokens.spacer.x2};
  `,
};

export { S };
